import { Link } from "react-router-dom";

/* ============================================================================
 * Pling — Bold, brutalist, gamified. Volt-yellow + hot pink on near-black.
 * Clash Display + JetBrains Mono. Solid drop-shadows, ALL CAPS, marquee energy.
 * ========================================================================== */

const P = {
  bg: "#0F0F0F", surface: "#1A1A1A", volt: "#E0FF00", pink: "#FF0055",
  text: "#FFFFFF", muted: "#888888", border: "#333333",
};
const D = "'Clash Display', 'Inter', sans-serif";
const M = "'JetBrains Mono', monospace";

export default function MockupPling() {
  return (
    <div style={{ background: P.bg, color: P.text, fontFamily: M, minHeight: "100vh" }}>
      <TopBar />
      <section style={{ maxWidth: 1180, margin: "0 auto", padding: "0 28px 100px" }}>
        <Section label="01 · LANDING"><PlingLanding /></Section>
        <Section label="02 · EXTENSION POPUP">
          <div style={{ padding: "60px 0", background: P.surface, border: `2px solid ${P.border}`, display: "flex", justifyContent: "center", position: "relative" }}>
            <div style={{ position: "absolute", inset: 0, backgroundImage: `repeating-linear-gradient(45deg, transparent 0 12px, ${P.border}33 12px 13px)` }} />
            <PlingPopup />
          </div>
        </Section>
        <Section label="03 · CONSUMER DASHBOARD"><PlingDashboard /></Section>
      </section>
    </div>
  );
}

function TopBar() {
  return (
    <div style={{ position: "sticky", top: 0, zIndex: 20, background: P.bg, borderBottom: `2px solid ${P.volt}` }}>
      <div style={{ maxWidth: 1180, margin: "0 auto", padding: "14px 28px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Link to="/mockups" style={{ fontSize: 11, color: P.muted, textDecoration: "none", letterSpacing: "0.25em", fontWeight: 700 }}>← ALLE RETNINGER</Link>
        <span style={{ fontFamily: D, fontSize: 24, fontWeight: 700, letterSpacing: "-0.03em" }}>PLING!</span>
        <span style={{ fontSize: 10, letterSpacing: "0.3em", color: P.volt, fontWeight: 700 }}>03 / 03</span>
      </div>
    </div>
  );
}

function Section({ label, children }) {
  return (
    <div style={{ paddingTop: 64 }}>
      <div style={{ fontSize: 10, letterSpacing: "0.3em", color: P.volt, fontWeight: 700, marginBottom: 18 }}>{label}</div>
      {children}
    </div>
  );
}

function PlingLanding() {
  return (
    <div style={{ background: P.surface, border: `2px solid ${P.border}` }}>
      <nav style={{ padding: "20px 36px", borderBottom: `2px solid ${P.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ fontFamily: D, fontSize: 30, fontWeight: 700, letterSpacing: "-0.03em" }}>PLING!</span>
        <div style={{ display: "flex", gap: 28, fontSize: 11, letterSpacing: "0.2em", color: P.muted, fontWeight: 700 }}>
          <span>STORES</span><span>POINTS</span><span>PRICING</span>
        </div>
        <button style={{ background: P.volt, color: "#000", border: "none", padding: "10px 18px", fontSize: 11, fontWeight: 700, letterSpacing: "0.2em", cursor: "pointer", boxShadow: `4px 4px 0 ${P.text}` }}>LOGG INN →</button>
      </nav>

      {/* Marquee */}
      <div style={{ background: P.volt, color: "#000", padding: "10px 0", overflow: "hidden", whiteSpace: "nowrap", fontSize: 13, fontWeight: 700, letterSpacing: "0.15em", borderBottom: `2px solid ${P.border}` }}>
        <span style={{ display: "inline-block" }}>★ 12 487 NORDMENN SAMLER POENG MED PLING ★ TRUMF 3% ★ EUROBONUS 15 P/100KR ★ COOP MEDLEM ★ 14 DAGER GRATIS ★ 15 KR/MND ★ NULL STRESS ★ BARE BONUS ★ &nbsp;&nbsp; ★ 12 487 NORDMENN SAMLER POENG MED PLING ★ TRUMF 3% ★ EUROBONUS 15 P/100KR ★</span>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1.3fr 1fr", padding: "64px 36px", gap: 48, alignItems: "center" }}>
        <div>
          <span style={{ display: "inline-block", padding: "6px 14px", background: P.pink, color: P.text, fontSize: 10, letterSpacing: "0.25em", fontWeight: 700, marginBottom: 24 }}>★ NYHET ★</span>
          <h1 style={{ fontFamily: D, fontSize: "clamp(64px, 9vw, 128px)", fontWeight: 700, letterSpacing: "-0.05em", lineHeight: 0.88, margin: 0, textTransform: "uppercase" }}>
            IKKE GÅ<br />GLIPP AV<br /><span style={{ color: P.volt }}>POENGENE</span><br />DINE!
          </h1>
          <p style={{ marginTop: 32, fontSize: 16, lineHeight: 1.55, color: P.muted, maxWidth: 440 }}>
            Pling skanner alle norske nettbutikker. Når det fins en bonus du har glemt — Trumf, EuroBonus, Coop — gir vi deg et lite varsel før du betaler.
          </p>
          <div style={{ marginTop: 36, display: "flex", gap: 14, flexWrap: "wrap", alignItems: "center" }}>
            <button style={{ background: P.volt, color: "#000", border: "none", padding: "18px 32px", fontSize: 14, fontWeight: 700, letterSpacing: "0.15em", cursor: "pointer", boxShadow: `6px 6px 0 ${P.pink}` }}>START GRATIS →</button>
            <span style={{ fontSize: 12, color: P.muted, fontWeight: 700, letterSpacing: "0.1em" }}>15 KR/MND DERETTER · NULL BINDING</span>
          </div>
        </div>

        {/* Sticker stack */}
        <div style={{ position: "relative", height: 460 }}>
          <div style={{ position: "absolute", top: 30, left: 30, width: 240, padding: 20, background: P.volt, color: "#000", transform: "rotate(-4deg)", boxShadow: `6px 6px 0 ${P.text}` }}>
            <div style={{ fontSize: 9, letterSpacing: "0.3em", fontWeight: 700 }}>KOMPLETT.NO</div>
            <div style={{ fontFamily: D, fontSize: 22, fontWeight: 700, marginTop: 6, letterSpacing: "-0.02em", textTransform: "uppercase" }}>🔥 VERIFISERT</div>
          </div>
          <div style={{ position: "absolute", top: 120, right: 0, width: 260, padding: 22, background: P.pink, transform: "rotate(3deg)", boxShadow: `6px 6px 0 ${P.text}` }}>
            <div style={{ fontSize: 9, letterSpacing: "0.3em", fontWeight: 700, color: P.text }}>SAS EUROBONUS</div>
            <div style={{ fontFamily: D, fontSize: 56, fontWeight: 700, lineHeight: 0.9, letterSpacing: "-0.04em", marginTop: 4 }}>+15 P</div>
            <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.15em", marginTop: 6 }}>PER 100 KR</div>
          </div>
          <div style={{ position: "absolute", bottom: 30, left: 80, width: 220, padding: 18, background: P.surface, border: `2px solid ${P.volt}`, transform: "rotate(-2deg)" }}>
            <div style={{ fontSize: 9, letterSpacing: "0.3em", color: P.volt, fontWeight: 700 }}>DENNE MÅNEDEN</div>
            <div style={{ fontFamily: D, fontSize: 36, fontWeight: 700, lineHeight: 1, marginTop: 6 }}>1 240</div>
            <div style={{ fontSize: 10, color: P.muted, letterSpacing: "0.15em", marginTop: 4 }}>POENG · +18%</div>
          </div>
        </div>
      </div>

      {/* Pricing card */}
      <div style={{ padding: "0 36px 64px" }}>
        <div style={{ background: P.volt, color: "#000", padding: "48px 40px", display: "grid", gridTemplateColumns: "1.4fr 1fr", gap: 32, alignItems: "center", boxShadow: `8px 8px 0 ${P.pink}` }}>
          <div>
            <div style={{ fontSize: 10, letterSpacing: "0.3em", fontWeight: 700, marginBottom: 12 }}>★ PLING MEDLEMSKAP ★</div>
            <div style={{ fontFamily: D, fontSize: 140, fontWeight: 700, letterSpacing: "-0.06em", lineHeight: 0.9 }}>15<span style={{ fontSize: 28 }}>KR</span></div>
            <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.15em" }}>PER MÅNED · 14 DAGER GRATIS</div>
          </div>
          <div>
            <ul style={{ listStyle: "none", padding: 0, margin: 0, fontSize: 14, fontWeight: 600, display: "grid", gap: 8 }}>
              {["UBEGRENSET SCANNING","BONUS-TRACKER FOR ALLE","MÅNEDLIG WRAPPED","DELELIG MED VENNER","AVSLUTT NÅR DU VIL"].map((l) => (
                <li key={l} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 0", borderBottom: "2px solid #000" }}><span>►</span>{l}</li>
              ))}
            </ul>
            <button style={{ marginTop: 24, background: "#000", color: P.volt, border: "none", padding: "16px 28px", fontSize: 13, fontWeight: 700, letterSpacing: "0.2em", cursor: "pointer", width: "100%" }}>BLI MED I PLING →</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function PlingPopup() {
  return (
    <div style={{ width: 360, background: P.bg, border: `2px solid ${P.volt}`, fontFamily: M, position: "relative", zIndex: 2, boxShadow: `8px 8px 0 ${P.pink}` }}>
      <div style={{ padding: "14px 20px", borderBottom: `2px solid ${P.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ fontFamily: D, fontSize: 20, fontWeight: 700, letterSpacing: "-0.02em" }}>PLING!</span>
        <span style={{ fontSize: 10, color: P.volt, letterSpacing: "0.2em", fontWeight: 700 }}>↻ SKANN</span>
      </div>

      <div style={{ padding: "16px 20px 10px" }}>
        <div style={{ fontSize: 9, letterSpacing: "0.3em", color: P.muted, fontWeight: 700 }}>NÅ PÅ</div>
        <div style={{ fontFamily: D, fontSize: 22, fontWeight: 700, letterSpacing: "-0.02em" }}>KOMPLETT.NO</div>
      </div>

      <div style={{ margin: "0 16px", padding: "12px 14px", background: P.volt, color: "#000" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span style={{ fontSize: 11, letterSpacing: "0.2em", fontWeight: 700 }}>🔥 VERIFISERT SHOP</span>
          <span style={{ fontSize: 10, letterSpacing: "0.15em", fontWeight: 700 }}>04 METODER</span>
        </div>
      </div>

      <div style={{ padding: "16px 20px 8px" }}>
        <div style={{ fontSize: 9, letterSpacing: "0.3em", color: P.muted, fontWeight: 700, marginBottom: 8 }}>BONUS · BANK PÅ POENG</div>
        <div style={{ background: P.pink, padding: "16px 18px", color: "#fff" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
            <div>
              <div style={{ fontFamily: D, fontSize: 40, fontWeight: 700, lineHeight: 1, letterSpacing: "-0.03em" }}>+15</div>
              <div style={{ fontSize: 10, letterSpacing: "0.2em", fontWeight: 700 }}>POENG / 100 KR</div>
            </div>
            <div style={{ textAlign: "right" }}>
              <div style={{ fontSize: 9, letterSpacing: "0.25em", fontWeight: 700 }}>SAS EUROBONUS</div>
              <div style={{ fontSize: 10, letterSpacing: "0.15em", marginTop: 4, color: P.volt, fontWeight: 700 }}>HENT NÅ →</div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ padding: "12px 20px 8px" }}>
        <div style={{ fontSize: 9, letterSpacing: "0.3em", color: P.muted, fontWeight: 700, marginBottom: 8 }}>BETALINGSMETODER</div>
        {["VISA","MASTERCARD","VIPPS","KLARNA"].map((m) => (
          <div key={m} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: `1px solid ${P.border}`, fontSize: 12, letterSpacing: "0.1em" }}>
            <span style={{ fontWeight: 700 }}>► {m}</span>
            <span style={{ color: P.volt, fontWeight: 700 }}>99%</span>
          </div>
        ))}
      </div>

      <div style={{ padding: "10px 20px 14px", borderTop: `2px solid ${P.border}`, marginTop: 6, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ fontSize: 9, color: P.muted, letterSpacing: "0.2em", fontWeight: 700 }}>4/7 · MØNSTER+AI</span>
        <div style={{ display: "flex" }}>
          <span style={{ padding: "3px 8px", background: P.volt, color: "#000", fontSize: 9, letterSpacing: "0.2em", fontWeight: 700 }}>NO</span>
          <span style={{ padding: "3px 8px", color: P.muted, fontSize: 9, letterSpacing: "0.2em", fontWeight: 700 }}>EN</span>
        </div>
      </div>
    </div>
  );
}

function PlingDashboard() {
  return (
    <div style={{ background: P.surface, border: `2px solid ${P.border}` }}>
      <nav style={{ padding: "18px 36px", borderBottom: `2px solid ${P.volt}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ display: "flex", gap: 40, alignItems: "center" }}>
          <span style={{ fontFamily: D, fontSize: 24, fontWeight: 700, letterSpacing: "-0.02em" }}>PLING!</span>
          <div style={{ display: "flex", gap: 26, fontSize: 11, letterSpacing: "0.2em", fontWeight: 700 }}>
            <span style={{ color: P.volt }}>► WRAPPED</span>
            <span style={{ color: P.muted }}>BUTIKKER</span>
            <span style={{ color: P.muted }}>POENG</span>
            <span style={{ color: P.muted }}>VENNER</span>
          </div>
        </div>
        <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
          <span style={{ fontSize: 10, letterSpacing: "0.2em", color: P.muted, fontWeight: 700 }}>NO / EN</span>
          <span style={{ width: 36, height: 36, background: P.volt, color: "#000", display: "grid", placeItems: "center", fontFamily: D, fontWeight: 700 }}>S</span>
        </div>
      </nav>

      <div style={{ padding: "40px 36px", borderBottom: `2px solid ${P.border}` }}>
        <div style={{ fontSize: 10, letterSpacing: "0.3em", color: P.volt, fontWeight: 700, marginBottom: 16 }}>★ DIN JUNI WRAPPED ★</div>
        <div style={{ fontFamily: D, fontWeight: 700, lineHeight: 0.85, letterSpacing: "-0.05em", textTransform: "uppercase", fontSize: "clamp(72px, 11vw, 168px)" }}>
          <span style={{ color: P.volt }}>1 240</span><br />POENG.
        </div>
        <div style={{ display: "flex", gap: 28, marginTop: 28, fontSize: 11, letterSpacing: "0.15em", fontWeight: 700 }}>
          <span style={{ color: P.muted }}>+18% VS MAI</span>
          <span style={{ color: P.pink }}>★ TOP 11% I OSLO</span>
          <span style={{ color: P.volt }}>= 124 KR</span>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", borderBottom: `2px solid ${P.border}` }}>
        {[["SAS EUROBONUS","800","POENG",P.pink],["TRUMF","2.8","%",P.volt],["COOP","98","KR",P.muted]].map(([n,v,u,c]) => (
          <div key={n} style={{ padding: 28, borderRight: `2px solid ${P.border}`, background: P.bg }}>
            <div style={{ fontSize: 10, letterSpacing: "0.25em", color: P.muted, fontWeight: 700, marginBottom: 16 }}>{n}</div>
            <div style={{ fontFamily: D, fontSize: 64, fontWeight: 700, color: c, letterSpacing: "-0.04em", lineHeight: 0.9 }}>{v}</div>
            <div style={{ fontSize: 11, letterSpacing: "0.2em", color: P.muted, fontWeight: 700, marginTop: 4 }}>{u}</div>
          </div>
        ))}
      </div>

      <div style={{ padding: "32px 36px" }}>
        <div style={{ fontSize: 10, letterSpacing: "0.3em", color: P.volt, fontWeight: 700, marginBottom: 18 }}>SISTE PLING-ER</div>
        {[
          ["KOMPLETT.NO", ["VISA","KLARNA"], "+15 P EUROBONUS", "I GÅR"],
          ["MENY.NO", ["VIPPS"], "+3% TRUMF", "2 DAGER"],
          ["XXL.NO", ["MC","VIPPS","KLARNA"], "+8 P EUROBONUS", "5 DAGER"],
          ["LEGO.COM", ["VISA","APPLE PAY"], "+2% TRUMF", "1 UKE"],
        ].map(([h,mm,b,t], i) => (
          <div key={h} style={{ display: "grid", gridTemplateColumns: "1.2fr 1.6fr 1.2fr 80px", padding: "14px 0", borderBottom: `1px solid ${P.border}`, alignItems: "center", fontSize: 12, letterSpacing: "0.08em" }}>
            <span style={{ fontFamily: D, fontWeight: 700, fontSize: 16, letterSpacing: "-0.01em" }}>► {h}</span>
            <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>{mm.map((x) => <span key={x} style={{ fontSize: 9, padding: "3px 8px", background: P.bg, border: `1px solid ${P.border}`, color: P.text, fontWeight: 700, letterSpacing: "0.15em" }}>{x}</span>)}</div>
            <span style={{ color: i === 0 ? P.pink : (i === 1 ? P.volt : P.pink), fontWeight: 700 }}>{b}</span>
            <span style={{ color: P.muted, textAlign: "right", fontWeight: 700 }}>{t}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
